import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import { getActionsConfig } from './action'
import * as extraReducers from './extra-reducers'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * TODO:
 */
export class Plugin<
  TTypeParams extends ec.models.TypeParams.Constraint,
> extends ec.plugins.Plugin<
  TTypeParams,
  typeof Plugin.id,
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static id = ec.plugins.Plugin.Id.Custom.create('DsColor')

  constructor({
    collection,
  }: Readonly<Plugin.constructor.Params<TTypeParams>>) {
    super({
      actions: getActionsConfig(),
      collection,
      id: Plugin.id,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })

    this.feature.registerExtraReducers(
      extraReducers.assignColorsToCurrentListOnLoad(this),
    )
  }
}
export namespace Plugin {
  export namespace constructor {
    export interface Params<
      TTypeParams extends ec.models.TypeParams.Constraint,
    > {
      collection: ec.Collection<TTypeParams>
    }
  }
}
